
    import React from 'react';
    import ProductListPageContainer from './ProductListPageContainer';
    
    export class ProductListPage extends React.Component{
        
        render(){
          return (
            <ProductListPageContainer {...this.props}/>
          )
        }
    }